import React from "react";

const PopupMessages = ({ show, type = "success", message }) => {
  if (!show) return null;

  const styles = {
    success: {
      bg: "bg-green-100",
      border: "border-green-300",
      circle: "bg-green-600",
      text: "text-green-800",
      icon: (
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      ),
    },

    error: {
      bg: "bg-red-100",
      border: "border-red-300",
      circle: "bg-red-600",
      text: "text-red-800",
      icon: (
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v3m0 4h.01M10.29 3.86l-7.09 12.28A1 1 0 004 18h16a1 1 0 00.86-1.52L13.77 3.86a1 1 0 00-1.74 0z" />
        </svg>
      ),
    },

    timeout: {
      bg: "bg-yellow-100",
      border: "border-yellow-300",
      circle: "bg-yellow-600",
      text: "text-yellow-800",
      icon: (
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z" />
        </svg>
      ),
    },

    network: {
      bg: "bg-blue-100",
      border: "border-blue-300",
      circle: "bg-blue-600",
      text: "text-blue-900",
      icon: (
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 12h.01M2 12a10 10 0 0120 0h-.01M8 12a4 4 0 018 0" />
        </svg>
      ),
    },
  };

  const current = styles[type] || styles.success;

  return (
    <div className="fixed top-10 left-1/2 transform -translate-x-1/2 z-50 w-full flex justify-center">
      <div
        className={`${current.bg} ${current.border} rounded-lg px-8 py-2 shadow-lg flex items-center space-x-3 min-w-[280px]`}
      >
        <div className="flex-shrink-0">
          <div className={`w-6 h-6 ${current.circle} rounded-full flex items-center justify-center`}>
            {current.icon}
          </div>
        </div>

        <span className={`${current.text} font-semibold text-sm`}>
          {message}
        </span>
      </div>
    </div>
  );
};

export default PopupMessages;
